module.exports = __webpack_public_path__ + "img/Coco.c4bdd1ee.jpeg";